<template>
  <div id="app">
    <div class="w-100" style="background-color: #f4f4f4">
      <b-row class="justify-content-center w-100" no-gutters>
        <b-col cols="12" sm="8" md="6" lg="4" xl="4">
          <div class="bg-white" style="min-height: 100vh">
            <router-view/>

          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
	metaInfo() {
    return {
      title: 'Goemas: Kami Membeli Semua Emas Anda Tanpa Surat Harga Tinggi',
      meta: [
        { name: 'description', content: 'Goemas: Kami Membeli Semua Emas Anda Tanpa Surat Harga Tinggi'},
        { property: 'og:title', content: 'Goemas: Kami Membeli Semua Emas Anda Tanpa Surat Harga Tinggi'},
        { property: 'og:site_name', content: 'Goemas: Kami Membeli Semua Emas Anda Tanpa Surat Harga Tinggi'},
        { property: 'og:description', content: 'Goemas: Kami Membeli Semua Emas Anda Tanpa Surat Harga Tinggi'},
        { property: 'og:type', content: 'profile'},
        { property: 'og:image', content: 'https://guestapps.s3-ap-southeast-1.amazonaws.com/website_general_setting/logo/133886c3-df9a-4393-809d-000393dbd68c_Untitled-2.png' }    
      ]
    }
  },
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue